/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type StorefrontProductTile_user = {
    readonly serviceId: string | null;
    readonly " $refType": "StorefrontProductTile_user";
};
export type StorefrontProductTile_user$data = StorefrontProductTile_user;
export type StorefrontProductTile_user$key = {
    readonly " $data"?: StorefrontProductTile_user$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"StorefrontProductTile_user">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "StorefrontProductTile_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};
(node as any).hash = '32609aab90ed10c6bdcfe0b4525e0027';
export default node;
